import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import App, { Home } from './App';
import ProjectDetails from './components/ProjectDetails';

// Create the router with future flags
const router = createBrowserRouter([
  {
    path: "/",
    element: <App />,
    children: [
      {
        index: true,
        element: <Home />,
      },
      {
        path: "project/:id",
        element: <ProjectDetails />,
      },
    ],
  },
], {
  // These are the future flags to enable
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
    v7_fetcherPersist: true,
  },
});

// Create a component that provides the router
export function AppRouter() {
  return <RouterProvider 
    router={router}
    future={{
      v7_startTransition: true,
      v7_relativeSplatPath: true,
      v7_fetcherPersist: true,
    }}
  />;
}

export default router;
